import React from 'react';
import { Phone, MessageCircle, MapPin, Clock, Shield } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-[#050505] border-t border-white/5" data-testid="footer">
      <div className="container mx-auto px-4 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand column */}
          <div className="lg:col-span-2">
            <h3 className="font-orbitron text-2xl font-black text-white uppercase tracking-wider mb-4">
              Doon <span className="text-cyan-400">Auto Glass</span>
            </h3>
            <p className="text-gray-400 mb-6 max-w-md">
              Your trusted partner for professional auto glass repair and replacement services in Dehradun. 
              Available 24/7 for all your windshield needs.
            </p>
            
            {/* Trust badges */}
            <div className="flex flex-wrap gap-3">
              <div className="flex items-center gap-2 bg-white/5 px-4 py-2 rounded-lg">
                <Shield className="w-4 h-4 text-cyan-400" />
                <span className="text-sm text-gray-300">Quality Guaranteed</span>
              </div>
              <div className="flex items-center gap-2 bg-white/5 px-4 py-2 rounded-lg">
                <Clock className="w-4 h-4 text-green-400" />
                <span className="text-sm text-gray-300">24/7 Service</span>
              </div>
            </div>
          </div>
          
          {/* Quick links */}
          <div>
            <h4 className="font-orbitron text-sm font-bold text-white uppercase tracking-wider mb-6">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {['Services', 'Why Choose Us', 'Contact'].map((item) => (
                <li key={item}>
                  <a 
                    href={`#${item.toLowerCase().replace(/\s/g, '-')}`}
                    className="text-gray-400 hover:text-cyan-400 transition-colors"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Contact info */}
          <div>
            <h4 className="font-orbitron text-sm font-bold text-white uppercase tracking-wider mb-6">
              Contact Us
            </h4>
            <ul className="space-y-4">
              <li>
                <a 
                  href="tel:+917300677651" 
                  className="flex items-center gap-3 text-gray-400 hover:text-cyan-400 transition-colors"
                >
                  <Phone className="w-4 h-4" />
                  <span>+91 7300677651</span>
                </a>
              </li>
              <li>
                <a 
                  href="https://wa.me/917300677651"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-gray-400 hover:text-green-400 transition-colors"
                >
                  <MessageCircle className="w-4 h-4" />
                  <span>WhatsApp Us</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-400">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span> Transport Nagar, Rajpur Road, Dehradun-248001, Uttarakhand</span>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-white/5">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm text-center md:text-left">
              © {currentYear} Doon Auto Glass. All rights reserved.
            </p>
            <p className="text-gray-600 text-xs">
              Premium Auto Glass Services in Dehradun
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
